import { render, staticRenderFns } from "./FaqsCategoryEdit.vue?vue&type=template&id=10d5ecfe&lang=pug"
import script from "./FaqsCategoryEdit.vue?vue&type=script&lang=js"
export * from "./FaqsCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports